import delivered from "../assets/orderStatusIcons/delivered.svg";
import dispatched from "../assets/orderStatusIcons/dispatched.svg";
import processing from "../assets/orderStatusIcons/processingIcon.svg";
import readyToDispatch from "../assets/orderStatusIcons/readyToDispatch.svg";

export const orderSummaryStages = [
  { title: "New", customerLabel: "Your order has been received" },
  {
    icon: processing,
    title: "Order Approved",
    customerLabel: "Payment confirmed, order is being processed",
  },
  {
    icon: processing,
    title: "Processing",
    customerLabel: "We're preparing your order",
  },
  {
    icon: readyToDispatch,
    title: "Ready for dispatch",
    customerLabel: "Your order is packed and ready to ship",
  },
  {
    icon: dispatched,
    title: "Dispatched",
    customerLabel: "Your order is on the way",
  },
  {
    icon: delivered,
    title: "Delivered",
    customerLabel: "Your order has been delivered",
  },
];
